async function get_configuracao_laboratorio_og(laboratorio) {
    const requestOptions = {
        method: "GET",
        headers: {
            access_token: sessionStorage.getItem("token"),
            laboratorio: laboratorio
        },
    };

    try {
        const response = await fetch(process.env.REACT_APP_ESSILOR_API + "rastreabilidade/configuracao-laboratorios/v1/laboratorio-disponivel/" + laboratorio, requestOptions);
        const data = await response.json();
        
        if (response.status === 200 && data) {
            return data;
        } else {
            return undefined;
        }
    } catch (error) {
        console.error("Erro ao obter configuração do laboratório OG:", error);
        return undefined;
    }
}

export { get_configuracao_laboratorio_og };